export const bulkAnswerRequiredFields = [
  {
    "id": "7306E1AD-745F-4BEE-829C-71BB380ED61B",
    "name": "text_input_06108B97-D7AC-42A5-8167-ECB948331A10",
    "custom_name": "text_input_06108B97-D7AC-42A5-8167-ECB948331A10",
    "value": ""
  },
  {
    "id": "99267192-0200-403C-813D-8AF374FE25D0",
    "name": "text_input_2F6A1BAF-2E0C-46BB-AD2E-617C3364D143",
    "custom_name": "text_input_2F6A1BAF-2E0C-46BB-AD2E-617C3364D143",
    "value": ""
  },
  {
    "id": "986AB1B0-19F0-4339-8594-59427982B41D",
    "name": "email_input_02B42DD9-B021-4B9A-B0C6-B6FF3B3D8EF2",
    "custom_name": "email_input_02B42DD9-B021-4B9A-B0C6-B6FF3B3D8EF2",
    "value": ""
  },
  {
    "id": "3A514A2D-58A7-4D33-9BA7-44551E571FD5",
    "name": "text_input_6D9C70EE-CC8C-4151-B941-032110B6695F",
    "custom_name": "text_input_6D9C70EE-CC8C-4151-B941-032110B6695F",
    "value": ""
  },
  {
    "id": "F027F052-CDF8-43E8-ADD5-5425F3BCFBAD",
    "name": "phone_input_B22E7BFA-488A-42A8-942D-59F9AFF66655",
    "custom_name": "phone_input_B22E7BFA-488A-42A8-942D-59F9AFF66655",
    "value": ""
}
]